function floatReturnKey(){
  const lsTimestamp = $('.agent-float-return-timestamp').data('local-storage-timestamp')

  return `float-return-data-${lsTimestamp}`
}

function getAgentId() {
  return $('#agent-dropdown option:selected').val()
}

function getAgentCodeId() {
  return $('#agent-dropdown option:selected').data('agent-code-id')
}

function getAgentName() {
  return $('#agent-dropdown option:selected').data('agent-name')
}

function getTillNumber() {
  return $('#agent-dropdown option:selected').data('agent-number')
}

function floatAmount() {
  return removeCommas($('#float-amount').val())
}

function setInitialFloatReturnData(view = 'edit', floatReturnAttr) {
  localStorage.removeItem(floatReturnKey())
  let floatReturnId = $('#float-return-form input[name="float_return[float_return_id]"').val()

  if (view === 'index') {
    floatReturnId = floatReturnAttr
  }
  const action = $('#float-return-form input[name="float_return[transfer_action]"').val()

  if (view === 'edit' && (action === 'create' || floatReturnId === null || floatReturnId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/float_return_details/${floatReturnId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      localStorage.setItem(floatReturnKey(), JSON.stringify(data))
      setFloatReturnRows()
    },
    error: function (data) {
      disableSubmit()
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setFloatReturnRows() {
  const floatReturnData = JSON.parse(localStorage.getItem(floatReturnKey()))

  if (floatReturnData === null || floatReturnData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".float-return-data").empty()

  // set data rows
  $.each(floatReturnData.details, function (key, floatReturnDetails) {
    if (floatReturnDetails === null) {
      return
    }
    const accountName = floatReturnDetails.account_name
    const details = floatReturnDetails.details
    const amount = floatReturnDetails.amount
    const elementId = floatReturnDetails.account_id

    $(".float-return-data").append(
      `<tr id='${elementId}'>
        <td class="account-name" >${accountName}</td>
        <td class="till-number text-right">${details}</td>
        <td class="total-amount text-right">${numberWithCommas(amount)}</td>
      </tr>`
    )
  })

  // const totalAmount = calculateTotalAmount()

  // set total row
  $(".float-return-data").append(
    `<tr id='float-return-total'>
      <td><strong>TOTAL</strong></td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${numberWithCommas(floatReturnData.total)}</strong>
      </td>
    </tr>`)

}

function calculateTotalAmount() {
  const data = JSON.parse(localStorage.getItem(floatReturnKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalAmount = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.amount)
  }, 0)

  return totalAmount
}

function submitFloatReturn() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const dateOfTransfer = $('#float-return-form input[name="float_return[created_at]"]').val()

    if (isEmpty(dateOfTransfer)) {
      errorString.push('date cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#float-return-form').attr('action')
      const cashSourceId = $(`select[name="float_return[cash_source_id]"] option:selected`).val()
      const returningAgentId = $(`select[name="float_return[returning_agent_id]"] option:selected`).val()
      const redirectUrl = `/float_returns?returning_agent_id=${returningAgentId}`
      const branchId = $('#float-return-form input[name="float_return[branch_id]"]').val()
      const paymentOptions = getPaymentOptionsStorage()

      let action = "post"

      if ($('#float-return-form input[name="float_return[transfer_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
         payment_options: paymentOptions,
         float_return: {
            branch_id: branchId,
            created_at: dateOfTransfer,
            cash_source_id: cashSourceId,
            returning_agent_id: returningAgentId,
            float: floatAmount(),
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(redirectUrl)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}


$(document).ready(function () {
  if ($('#float-return-form').length > 0 && $('.amount-div').length > 0) {
    checkAmount('.amount', '.amount-div');

    submitFloatReturn()
    clearFailedSubmit('#float-return-form')

  }

  $('.view-float-return-details').click(function () {
    const floatReturnId = $(this).data('float-return-id')
    setInitialFloatReturnData('index', floatReturnId)
    localStorage.removeItem(floatReturnKey())
  })

});
